import React, { useState } from "react";
import { usePlayerStore } from "../store/store";
import './healthbar.css';

function HealthBar() {
    const [showPercentage, setShowPercentage] = useState(false);
    const [freeze, setFreeze] = useState(false);
    const hp = usePlayerStore((state) => state.health);
    const percentage = ((100 * hp.current) / hp.max).toFixed(0);
    const width = percentage > 100 ? '100%' : (percentage < 0 ? '0%' : percentage + '%');

    const handleMouseExit = (e) => {
        freeze ? setShowPercentage(true) : setShowPercentage(false);
    }

    const handleMouseEnter = (e) => {
        freeze ? setShowPercentage(false) : setShowPercentage(true);
    }
    const handleFreeze = (e) => {
        setFreeze(!freeze);
    }

    return (
        <div className="vitials">
            <div className="health-outer">
                <div className="health-inner"
                    style={{ width: width }} >
                </div>
                <div className="health-info"
                    onMouseOver={handleMouseEnter}
                    onMouseOut={handleMouseExit}
                    onClick={handleFreeze}>
                    <p>Health: {showPercentage ? percentage + '%' : hp.current + ' / ' + hp.max} </p>
                </div>
            </div>
        </div>
    );
}

export default HealthBar;